module.exports = __webpack_public_path__ + "img/money.443b67e1.svg";